/**
 * Tela de carregamento animada com marca Agiliza
 */

export function LoadingScreen() {
  const systemLogoSymbol = "/logo_complete_pack/logo.svg";

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-primary-50 via-white to-secondary-50">
      <div className="text-center">
        <div className="relative">
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="h-24 w-24 animate-ping rounded-full border-4 border-primary-200 opacity-75"></div>
          </div>
          <div className="relative flex items-center justify-center">
            <div className="h-20 w-20 animate-spin rounded-full border-b-4 border-t-4 border-primary-600"></div>
            <div className="animate-spin-reverse absolute h-16 w-16 rounded-full border-l-4 border-r-4 border-secondary-400"></div>
            <div className="absolute flex h-12 w-12 items-center justify-center rounded-full bg-white shadow-lg ring-1 ring-primary-100">
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                src={systemLogoSymbol}
                alt="Agiliza"
                className="h-8 w-8 object-contain"
              />
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes spin-reverse {
          from {
            transform: rotate(360deg);
          }
          to {
            transform: rotate(0deg);
          }
        }

        .animate-spin-reverse {
          animation: spin-reverse 1.5s linear infinite;
        }
      `}</style>
    </div>
  );
}

/**
 * Loading inline para uso dentro de containers
 */
export function LoadingInline({
  label,
  size = "sm",
}: {
  label?: string;
  size?: "sm" | "md" | "lg";
}) {
  const systemLogoSymbol = "/logo_complete_pack/logo.svg";

  const sizeMap = {
    sm: {
      outer: "w-12 h-12",
      middle: "w-10 h-10",
      inner: "w-6 h-6",
      logo: "h-4 w-4",
      text: "text-sm",
    },
    md: {
      outer: "w-14 h-14",
      middle: "w-12 h-12",
      inner: "w-8 h-8",
      logo: "h-5 w-5",
      text: "text-base",
    },
    lg: {
      outer: "w-16 h-16",
      middle: "w-14 h-14",
      inner: "w-10 h-10",
      logo: "h-6 w-6",
      text: "text-base",
    },
  } as const;

  const selected = sizeMap[size];

  return (
    <div className="flex items-center justify-center py-12">
      <div className="text-center">
        <div className="relative">
          <div className="relative flex items-center justify-center">
            <div
              className={`${selected.outer} animate-spin rounded-full border-b-3 border-t-3 border-primary-600`}
            ></div>
            <div
              className={`absolute ${selected.middle} animate-spin-reverse rounded-full border-l-3 border-r-3 border-secondary-400`}
            ></div>
            <div
              className={`absolute ${selected.inner} flex items-center justify-center rounded-full bg-white ring-1 ring-primary-100`}
            >
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                src={systemLogoSymbol}
                alt="Agiliza"
                className={`${selected.logo} object-contain`}
              />
            </div>
          </div>
        </div>

        {label ? (
          <p className={`mt-4 font-medium text-slate-700 ${selected.text}`}>{label}</p>
        ) : null}

        <style jsx>{`
          @keyframes spin-reverse {
            from {
              transform: rotate(360deg);
            }
            to {
              transform: rotate(0deg);
            }
          }

          .animate-spin-reverse {
            animation: spin-reverse 1.5s linear infinite;
          }
        `}</style>
      </div>
    </div>
  );
}
